export default __webpack_public_path__ + "static/media/flowsBuilderConfirmation.cdcb9210.svg";